import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'ADOSC',
  version: 1,
  label: 'Chaikin A/D Oscillator',
  pane: 'sub',
  category: 'volume',
  series: 'volume',
  order: 110,
  inputs: [period('fastperiod', 3, 'Fast length'), period('slowperiod', 10, 'Slow length')],
  outputs: [line('adosc', 'ADOSC', COLOR.blue)],
  levels: [{ value: 0 }],
  talib: { functions: ['ADOSC'], expr: 'ADOSC(high, low, close, volume, fastperiod={fastperiod}, slowperiod={slowperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, slowperiod }) => Math.max(fastperiod, slowperiod) - 1,
}
export default def
